import { render, staticRenderFns } from "./google-card.html?vue&type=template&id=e32c4966&scoped=true&"
import script from "./google-card.js?vue&type=script&lang=js&"
export * from "./google-card.js?vue&type=script&lang=js&"
import style0 from "./google-card.scss?vue&type=style&index=0&id=e32c4966&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32c4966",
  null
  
)

export default component.exports